import { ResetPasswordContainer } from '@/features/auth/containers/reset-password-container';

export default function ResetPasswordPage() {
  return <ResetPasswordContainer />;
}
